import { typographyTokens, ACTIVE_SURFACE_MUTED } from "@/shared/theme";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { InfoControl } from "@/shared/components/InfoControl";

export const MicroLabel = ({ children, inverse = false }: { children: React.ReactNode; inverse?: boolean }) => (
  <Typography
    sx={{
      color: inverse ? ACTIVE_SURFACE_MUTED : "text.secondary",
      fontSize: "caption.fontSize",
      fontWeight: "fontWeightBold",
      letterSpacing: typographyTokens.tracking.label,
      textTransform: "uppercase",
    }}
  >
    {children}
  </Typography>
);

type InfoTitleProps = {
  children: React.ReactNode;
  info: string;
  inverse?: boolean;
  containerSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
};

type SxEntry = Extract<SxProps<Theme>, readonly unknown[]>[number];

export const InfoTitle = ({ children, info, inverse = false, containerSx, titleSx }: InfoTitleProps) => {
  const inheritedContainerSx = Array.isArray(containerSx)
    ? (containerSx as readonly SxEntry[])
    : containerSx
      ? [containerSx as SxEntry]
      : [];

  return (
    <Box sx={[{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }, ...inheritedContainerSx]}>
      <Typography sx={titleSx}>{children}</Typography>
      <InfoControl
        label={typeof children === "string" ? children : "this pattern"}
        description={info}
        inverted={inverse}
        interactive={false}
      />
    </Box>
  );
};
